import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import "flag-icons/css/flag-icons.min.css";

countries.registerLocale(enLocale);

interface CountryFlagProps {
  countryName?: string | null;
  size?: number;
  className?: string;
}

const CountryFlag = ({
  countryName,
  size = 16,
  className = "",
}: CountryFlagProps) => {
  if (!countryName) return null;

  const countryCode = countries.getAlpha2Code(countryName.trim(), "en");

  if (!countryCode) return null;

  return (
    <span
      className={`fi fis fi-${countryCode.toLowerCase()} shrink-0 rounded-full ${className}`}
      style={{ width: size, height: size, backgroundSize: "cover" }}
      title={countryName}
      aria-label={countryName}
    />
  );
};

export default CountryFlag;